import React, { ReactNode } from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import { DNABox, DNADivider, DNAText } from '@alucio/lux-ui';
import { HelpCircleTooltip } from 'src/components/DNA';

type GenericComponent<P = {}> = React.FC<P & {
  testID?: string;
  style?: object;
  children?: ReactNode;
}>;

type SidebarContentProps = GenericComponent & {
  Header: typeof Header,
  Body: typeof Body,
}

type HeaderProps = {
  sidebarHeader: string,
  rightElement?: React.ReactNode,
  descriptionText?: string,
}

export const styles = StyleSheet.create({
  sideBarHeaderContainer: {
    minHeight: 75,
    padding: 18,
  },
  sidebarContentContainer: {
    paddingHorizontal: 24,
    paddingBottom: 20,
  },
  helpCircleTooltip: {
    marginLeft: 5,
  },
});

const SidebarContent: SidebarContentProps = (props) => {
  const { children } = props

  return (
    <DNABox
      testID={'content-preview-modal-side-bar-scroll-view'}
      fill
      as={ScrollView}
      style={{ width: 320 }}
      spacing="md"
      appearance="col"
      childFill={1}
    >
      {children}
    </DNABox>
  )
}

const Header: GenericComponent<HeaderProps> = (props) => {
  const { sidebarHeader, rightElement, descriptionText } = props

  return (
    <DNABox
      testID="side-bar-header-text"
      appearance="col"
      style={styles.sideBarHeaderContainer}
      spacing="between"
    >
      <DNABox fill appearance="row" spacing="between">
        <DNABox alignY="center">
          <DNAText testID="side-bar-text" h4>
            {sidebarHeader}
          </DNAText>
          {descriptionText && <HelpCircleTooltip popoverText={descriptionText} style={styles.helpCircleTooltip} />}
        </DNABox>
        {rightElement && rightElement}
      </DNABox>
      <DNADivider />
    </DNABox>
  )
}

const Body: GenericComponent<{}> = (props) => {
  const { children } = props
  return (
    <DNABox appearance="col" fill style={styles.sidebarContentContainer}>
      {children}
    </DNABox>
  )
}

SidebarContent.displayName = 'SidebarContent'
SidebarContent.Header = Header
SidebarContent.Body = Body

export default SidebarContent
